export const CUSTOM_GATEWAYS_STORAGE_KEYS = {
  CORE: "mt6_custom_gateways_core",
} as const;
